import { render, staticRenderFns } from "./EdicoesAbertas.vue?vue&type=template&id=7daa132a&scoped=true&"
import script from "./EdicoesAbertas.vue?vue&type=script&lang=js&"
export * from "./EdicoesAbertas.vue?vue&type=script&lang=js&"
import style0 from "./EdicoesAbertas.vue?vue&type=style&index=0&id=7daa132a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daa132a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
